import React, { ReactNode } from 'react';
import { Link, generatePath } from 'react-router-dom';
import { kebabCase } from 'lodash';

import routeMap from 'config/routes';
import { DspConnection } from 'types';
import { TextEmphasis } from '@protonradio/proton-ui';

/**
 * [getDspConnectionSubtitle] - returns the subtitle for the DspConnection page.
 */

interface DspConnectionInfo {
  serviceName: string;
  artistName?: string;
  artistId?: number;
  artistConnection?: DspConnection;
  canDisconnectProfile: boolean;
}

export const getDspConnectionSubtitle = ({
  serviceName,
  artistName,
  artistId,
  artistConnection,
  canDisconnectProfile
}: DspConnectionInfo): ReactNode => {
  if (!artistId) return null;

  if (canDisconnectProfile && artistConnection) {
    const settingsPath = routeMap.artists.root + routeMap.artists.settings.root;
    const editorUrl = generatePath(settingsPath, {
      id: artistId,
      name: kebabCase(artistName)
    });

    return (
      <>
        The below {serviceName} profile for <TextEmphasis>{artistName}</TextEmphasis> has
        already been connected. If this is the incorrect profile, please disconnect the
        profile in your <Link to={editorUrl}>artist settings</Link>.
      </>
    );
  }

  if (artistConnection) {
    return (
      <>
        The {serviceName} profile for <TextEmphasis>{artistName}</TextEmphasis> has
        already been connected. If you need to change this, you&apos;ll need to first
        contact <a href="mailto:support@protonradio.com">support@protonradio.com</a>.
      </>
    );
  }

  return (
    <>
      Please match <TextEmphasis>{artistName}</TextEmphasis> to their existing{' '}
      {serviceName} profile
    </>
  );
};
